import { defineAsyncComponent } from "vue";
import { registerEntityEndpoint } from "@editor/ui-utils";
const de = {
  chipWidget: {
    contentBlockLabel: "Chip-Widget",
    inputIDLabel: "Chip-Widget-ID (cwc-id)",
    inputTypeLabel: "Chip-Widget-Typ",
    openConfiguratorButton: "Chip-Widget-Konfigurator",
    InvalidWidgetType: "{widget} ist nicht Teil der verfügbaren Widget-Typen. Bitte wählen Sie ein anderes Widget",
    widgetTypeNotAllowed: "Diese Widgetart ist nicht erlaubt"
  }
};
const en = {
  chipWidget: {
    contentBlockLabel: "Chip Widget",
    inputIDLabel: "Chip Widget Id(cwc-id)",
    inputTypeLabel: "Chip Widget Type",
    openConfiguratorButton: "Chip Widget Configurator",
    InvalidWidgetType: "{widget} is not part of available widget types. Please select another widget",
    widgetTypeNotAllowed: "This widget type is not allowed"
  }
};
const messages = { en, de };
const ChipWidgetModelName = "chip-widget";
const ChipWidgetService = registerEntityEndpoint(ChipWidgetModelName);
const { getEntity, postEntity } = ChipWidgetService;
const CwcWidgetModelName = "cwc-widget";
const CwcWidgetService = registerEntityEndpoint(CwcWidgetModelName);
const { getEntityAPIClient } = CwcWidgetService;
const getCwcCredentials = async (brand) => {
  const response = await getEntityAPIClient().get("credentials", {
    params: {
      brand
    }
  });
  return response.data;
};
const getChipWidget = async (id) => {
  return getEntity(id);
};
const postChipWidget = async (chipWidget) => {
  return postEntity({
    ...chipWidget
  });
};
const getAllowedWidgetTypes = () => {
  return ["pro-con-list", "top-list", "download-widget", "table", "ir-boost-list", "deal-widget"];
};
const ChipWidgetBlock = defineAsyncComponent(() => import("./chip-widget-block-D4zl7cK5.js"));
const ChipWidgetModule = {
  messages,
  routes: [],
  contentBlocks: [
    {
      type: "CHIP_WIDGET",
      label: "chipWidget.contentBlockLabel",
      icon: "note",
      component: ChipWidgetBlock,
      defaultValue: { type: "CHIP_WIDGET" }
    }
  ]
};
export {
  ChipWidgetBlock,
  ChipWidgetModelName,
  ChipWidgetModule,
  ChipWidgetService,
  CwcWidgetService,
  getAllowedWidgetTypes,
  getChipWidget,
  getCwcCredentials,
  postChipWidget
};
//# sourceMappingURL=index.es.js.map
